import BecomeExpertApplyComponent from "../../components/become-expert/become-expert-apply"
import BecomeExpertApplyComponentSteps from "../../components/become-expert/become-expert-apply copy";

const BecomeExpertApplyPage = () => <BecomeExpertApplyComponent />

export default BecomeExpertApplyPage;